import React from 'react';
import { Icon } from '@iconify/react';

interface BadgeIconProps {
    channelTypeName: string;
    mediumName: string;
}

const MediumBadge: React.FC<BadgeIconProps> = ({ channelTypeName, mediumName }) => {
    if (
        (channelTypeName === 'Page' && mediumName === 'Facebook') ||
        (channelTypeName === 'Group' && mediumName === 'Facebook')
    ) {
        return <Icon icon="logos:facebook" />;
    } else if (channelTypeName === 'YoutubeChannel' && mediumName === 'Google') {
        return <Icon icon="openmoji:youtube" />;
    } else if (channelTypeName === 'PinterestBoard' && mediumName === 'Pinterest') {
        return <Icon icon="logos:pinterest" />;
    }

    return null;  // Return null or a default icon if no conditions are met
};

export default MediumBadge;
